/**
 * View component for /sentiment-answers/:sentimentAnswerId
 *
 * Displays a single sentimentAnswer from the 'byId' map in the sentimentAnswer reducer
 * as defined by the 'selected' property
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as sentimentAnswerActions from '../sentimentAnswerActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import sentimentAnswer components
import SentimentAnswerLayout from '../components/SentimentAnswerLayout.js.jsx';

// import sentimentAnswer css modules
import sentimentAnswerStyles from '../sentimentAnswerModuleStyles.css';


class SingleSentimentAnswer extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(sentimentAnswerActions.fetchSingleIfNeeded(match.params.sentimentAnswerId));
  }

  render() {
    const { sentimentAnswerStore } = this.props;

    /**
     * use the selected.getItem() utility to pull the actual sentimentAnswer object from the map
     */
    const selectedSentimentAnswer = sentimentAnswerStore.selected.getItem();

    const isEmpty = (
      !selectedSentimentAnswer
      || !selectedSentimentAnswer._id
      || sentimentAnswerStore.selected.didInvalidate
    );

    return (
      <SentimentAnswerLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <h3> Single Sentiment Answer </h3>
              {isEmpty ?
                (sentimentAnswerStore.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                <div style={{ opacity: sentimentAnswerStore.isFetching ? 0.5 : 1 }}>
                  <h1> { selectedSentimentAnswer.name }
                    <Link className="yt-btn small u-pullRight" to={`${this.props.match.url}/update`}> UPDATE Sentiment Answer </Link>
                  </h1>
                  <hr/>
                  <p> <em>Other characteristics about the Sentiment Answer would go here.</em></p>
                </div>
              }
            </div>
          </section>
        </div>
      </SentimentAnswerLayout>
    )
  }
}

SingleSentimentAnswer.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    sentimentAnswerStore: store.sentimentAnswer
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(SingleSentimentAnswer)
);



// WEBPACK FOOTER //
// modules/sentimentAnswer/views/SingleSentimentAnswer.js.jsx